import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  pageViewStyles: {
    minHeight: '300px',
    overflow: 'auto',
    padding: '10px',
    marginBottom: 5,
  },
  tableContainerAutoSync: {
    width: '50%',
    overflowY: 'auto',
    border: '3px solid rgb(224, 224, 224)',
    borderRadius: '6px',
  },
}));
